// extracted by mini-css-extract-plugin
module.exports = {"form_actions":"EditSlotForm_form_actions__fEdFK"};